import BmvDialog from './BmvDialog.vue'
import BmvToastContainer from './BmvToastContainer.vue'

function mountSingleton(Vue, Component) {
    const Ctor = Vue.extend(Component)
    const instance = new Ctor()
    instance.$mount()
    document.body.appendChild(instance.$el)
    return instance
}

export default {
    install(Vue) {
        if (typeof window === 'undefined') return

        const dialogInstance = mountSingleton(Vue, BmvDialog)
        const toastInstance = mountSingleton(Vue, BmvToastContainer)

        Vue.prototype.$bmvDialog = {
            confirm(options = {}) {
                return dialogInstance.open({ ...options, kind: 'confirm' })
            },
            alert(options = {}) {
                return dialogInstance.open({ ...options, kind: 'alert' })
            }
        }

        Vue.prototype.$bmvToast = {
            open(options) { return toastInstance.open(options) },
            success(message, title = '') { return toastInstance.open({ type: 'success', message, title }) },
            error(message, title = '') { return toastInstance.open({ type: 'error', message, title }) },
            warning(message, title = '') { return toastInstance.open({ type: 'warning', message, title }) },
            info(message, title = '') { return toastInstance.open({ type: 'info', message, title }) },
            dismiss(id) { return toastInstance.dismiss(id) }
        }
    }
}
